import { render, staticRenderFns } from "./Topbr.vue?vue&type=template&id=350f6438&scoped=true&"
import script from "./Topbr.vue?vue&type=script&lang=js&"
export * from "./Topbr.vue?vue&type=script&lang=js&"
import style0 from "./Topbr.vue?vue&type=style&index=0&id=350f6438&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "350f6438",
  null
  
)

export default component.exports